/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetActiveInstrumentSyncEntitiesRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/GetActiveInstrumentSyncEntities.pb'
import {GetActiveInstrumentSyncEntitiesResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/GetActiveInstrumentSyncEntities.pb'


export const getActiveInstrumentSyncEntities = (request:GetActiveInstrumentSyncEntitiesRequest, options?: CashRequestOptions) => post<GetActiveInstrumentSyncEntitiesRequest, GetActiveInstrumentSyncEntitiesResponse>("/2.0/cash/get-active-instrument-sync-entities", request, {...options, rejectOnError: true })